"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var doshx_controls_web_1 = require("doshx_controls_web");
function useRenderCellViews() {
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        var _a, _b;
        return [
            { key: "loyaltynumber", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: (_a = cellValue === null || cellValue === void 0 ? void 0 : cellValue.card) === null || _a === void 0 ? void 0 : _a.number })) },
            { key: "loyalty_number", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })) },
            { key: "linked", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small text-default-foreground" }, { children: ((_b = cellValue === null || cellValue === void 0 ? void 0 : cellValue.card) === null || _b === void 0 ? void 0 : _b.linked) ? "Yes" : "No" })) },
            { key: "member_date", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: doshx_controls_web_1.Utilities.formatDateTime(cellValue) })) },
            { key: "customer", content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })) },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
exports.useRenderCellViews = useRenderCellViews;
